export default __webpack_public_path__ + "static/media/sunset.e7aac810.svg";